import { Stack, Button } from '@mui/material';
import type { TabNavigationProperties } from '@/types/application/common/components/layout/tab-navigation';

export function TabNavigation({ tabs, activeTab, onTabChange }: TabNavigationProperties) {
  return (
    <Stack
      direction="row"
      gap={0.5}
      mb={3}
      sx={{ borderBottom: '1px solid', borderColor: 'divider', pb: 0.5 }}
    >
      {tabs.map((tab) => (
        <Button
          key={tab.id}
          size="small"
          onClick={() => onTabChange(tab.id)}
          sx={{
            px: 2,
            py: 0.75,
            color: activeTab === tab.id ? '#23395d' : '#64748b',
            fontWeight: activeTab === tab.id ? 700 : 500,
            borderBottom: activeTab === tab.id ? '2px solid' : '2px solid transparent',
            borderColor: activeTab === tab.id ? '#23395d' : 'transparent',
            borderRadius: 0,
            textTransform: 'none',
            '&:hover': { 
              bgcolor: 'transparent', 
              color: '#23395d',
            },
          }}
        >
          {tab.label}
        </Button>
      ))}
    </Stack>
  );
}

export default TabNavigation;


